import { RangeSliderThumb, Tooltip } from '@chakra-ui/react';

interface RangeSliderThumbWithTooltipProps {
  index: number;
  tooltipLabel?: string;
  showTooltip?: boolean;
  onTooltipOpen?: () => void;
  onTooltipClose?: () => void;
}

export const RangeSliderThumbWithTooltip = ({
  index,
  tooltipLabel,
  showTooltip = true,
  onTooltipOpen,
  onTooltipClose,
}: RangeSliderThumbWithTooltipProps) => {
  const sliderThumb = (
    <RangeSliderThumb
      index={index}
      pointerEvents="auto"
      onClick={onTooltipOpen}
      onMouseEnter={onTooltipOpen}
      onMouseLeave={onTooltipClose}
    />
  );

  if (!showTooltip) {
    return sliderThumb;
  }

  return (
    <Tooltip
      backgroundColor="gray.400"
      borderRadius="3px"
      color="indigo.800"
      hasArrow={true}
      isDisabled={!tooltipLabel}
      isOpen={showTooltip}
      label={tooltipLabel}
      placement="top"
      px={1}
      py={0}
      variant="muted"
    >
      {sliderThumb}
    </Tooltip>
  );
};
